const DAY_MS = 24 * 60 * 60 * 1000;

// Whole days between two UTC midnights. date-fns' differenceInDays counts in the
// browser's timezone, so across a DST switch it loses a day for UTC-midnight dates.
const differenceInUtcDays = (later: Date, earlier: Date) =>
  Math.round((later.getTime() - earlier.getTime()) / DAY_MS);

export default differenceInUtcDays;
